import { AxiosError, AxiosResponse } from "axios";
import Core from "../core";

async function getEmployeeCurrentSalary(employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getSalaryByEmployee?empId=${employee_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getEmployeeAssignGovtTax(
  company_id: number,
  employee_id: number
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmployeeGovTaxes?company_id=${company_id}&emp_id=${employee_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function editEmpGovernmentTax(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/editEmpGovernmentTaxPortal`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getPayHistory(emp_id: number, company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getPaySlip?companyId=${company_id}&empId=${emp_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getPayHistoryWithYear(
  emp_id: number,
  company_id: number,
  year: number
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getPaySlip?companyId=${company_id}&empId=${emp_id}&year=${year}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function updateEmpSalary(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/setSalary`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const salaryService = {
  getEmployeeCurrentSalary,
  getEmployeeAssignGovtTax,
  editEmpGovernmentTax,
  getPayHistory,
  updateEmpSalary,
  getPayHistoryWithYear,
};
